<cs-icon name="calendar-today" (click)="handleCalendarClick($event)"></cs-icon>

<div class="date-inputs">
  @for (order of formatOrders; track order; let orderIndex = $index) {
    @if (order === 'day') {
      <input [value]="textDay" autocomplete="off" [placeholder]="LL.common.placeholders.day()" class="day"
        (change)="handleDayChange($event)">
    }
    @if (order === 'month') {
      <input list="months" [value]="textMonth" [placeholder]="LL.common.placeholders.month()" class="month"
        (change)="handleMonthChange($event)" (focus)="onMonthInputFocus($event)" (mousedown)="onMonthInputClick($event)"
        (blur)="onMonthInputBlur($event)">
      <datalist id="months">
        @for (month of months; track month) {
          <option [value]="month.short">
          }
        </datalist>
      }
      @if (order === 'year') {
        <input [value]="textYear" autocomplete="off" [placeholder]="LL.common.placeholders.year()" class="year"
          (change)="handleYearChange($event)">
      }
      @if (orderIndex < 2) {
        <span class="separator">{{separator}}</span>
      }
    }
  </div>

  <!-- data-cs-name-owner keeps the capture-cover directive from naming this button after the host's text, which is only the date separators -->
  <button cs-capture-cover data-cs-name-owner (click)="handleButtonClick($event)"></button>
